import React, { Component } from 'react';
import { routerShape } from 'react-router';
import PropTypes from 'prop-types';
import findIndex from 'lodash/findIndex';
import filter from 'lodash/filter';
import includes from 'lodash/includes';
import isArray from 'lodash/isArray';
import { authConnect, UserProp } from 'auth';
import apiDecorator from 'api/api-decorator';
import { reportError } from 'api/api-errors';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import formatDate from 'helpers/formatDate';
import beautifyNumber from 'helpers/beautifyNumber';
import numDesc from 'helpers/numDesc';
import { emit } from 'helpers/global-events';
// import Complaint from 'subsys/complaint';
import Link from 'components/link';
import { Thumb } from 'components/image';
import AdSense from 'components/adsense';
import { ModalButton, Header, Content } from 'components/modal';
import TabControl from 'components/tab-control';
import Block, { BlockContent } from 'components/block';
import Button, { btnViews } from 'components/button';
import DropDown, { close as ddClose } from 'components/drop-down';
import Icon, { iconTypes } from 'components/icon';
import StringCutter from 'components/string-cutter';
import Notification from 'components/notification';
import Share from 'components/share';
import SubscribeModal from 'components/subscribe-modal';
import { Col } from 'components/row';

import linksForum from 'src-sites/forum/links';

import AdminPanel from '../../common/admin/panel';
import ClubButtonJoin from './club-button-join';
import ClubUserAddForm from './club-user-add-form';
import ForumTopicAdd from '../../common/forum-topic-add';
import ClubContent from './club-content';

import translates from '../../forum-i18n';

const bemClasses = new Bem('clubBlock');
const bemClassesBlock = new Bem('clubBlockShadow');
const bemClassesDD = new Bem('dropDownList');

@authConnect()
@apiDecorator
@I18nHoc(translates())
export default class ClubInfo extends Component {
  static propTypes = {
    className: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.shape({})),
    params: PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      status: PropTypes.string,
      url: PropTypes.string
    }),
    showDesc: PropTypes.bool,
    auth: UserProp,
    actionDoLogin: PropTypes.func,
    router: routerShape,
    noHeaderTag: PropTypes.bool,
    noThemesList: PropTypes.bool,

    // Preloaded data
    preloadedClubTopicList: PropTypes.shape({}),
    preloadedClubUsersList: PropTypes.shape({})
  };

  constructor(props, ctx) {
    super(props, ctx);
    this.readAllTopics = this.readAllTopics.bind(this);
    this.topicsSawMessage = this.topicsSawMessage.bind(this);
    this.closeMainDropdown = this.closeMainDropdown.bind(this);
    this.showTitle = this.showTitle.bind(this);
    this.onHandleSelect = this.onHandleSelect.bind(this);
    this.onHandleDeleteTheme = this.onHandleDeleteTheme.bind(this);
    this.renderClubContent = this.renderClubContent.bind(this);

    this.state = {
      selectedThemes: null
    };
  }

  componentWillReceiveProps({ auth: nextAuth = {} }) {
    const { auth = {} } = this.props;
    if (
      (!auth.authenticated && auth.authenticated !== nextAuth.authenticated) ||
      (auth.authenticated && auth.authenticated !== nextAuth.authenticated)
    ) {
      if (this.state.selectedThemes) this.setState({ selectedThemes: null });
      emit('updateClubList');
      emit('updateClubTopics');
      emit('updateVote');
    }
  }

  onHandleDeleteTheme() {
    console.log('theme deleted'); // eslint-disable-line
  }

  /**
   * Add/remove selected themes in state. Admin logic only.
   *
   * @param checked
   * @param data {object || array}
   */
  onHandleSelect(checked, data) {
    let selectedThemes = this.state.selectedThemes ? [...this.state.selectedThemes] : [];

    if (!isArray(data)) {
      const index = findIndex(selectedThemes, it => it.id === data.id);

      if (checked) selectedThemes.push(data);
      if (!checked && index >= 0) selectedThemes.splice(index, 1);
      if (!selectedThemes.length) selectedThemes = null;

      return this.setState({ selectedThemes });
    }

    selectedThemes = filter(selectedThemes, post => !includes(data, post));
    this.setState({ selectedThemes });
  }

  // Show success message.
  topicsSawMessage() {
    Notification.success('Все темы помечены, как прочитанные.');
    emit('updateClubTopics');
  }

  // If user clicked to button read all topics (mark as saw).
  readAllTopics(forum_id) {
    const { auth: { authenticated } = {} } = this.props;

    if (authenticated) {
      this.api.post('action/forum/actions-saw-all-topics/saw-all', {
        postData: {
          forum_id
        }
      })
        .then(() => this.topicsSawMessage())
        .catch(error => reportError(error));
    }
  }

  closeMainDropdown() {
    if (this.ddRefMain) ddClose(this.ddRefMain);
  }

  // Show title or link to club (main page).
  showTitle(data) {
    const { pathname } = this.props.router.location;
    const pathClub = `/clubs/${data.clubUrl}-c${data.id}`;
    const forumTitle = (
      <div {...bemClasses('text')}>
        <h1 children={data.forum_title} />
      </div>
    );

    // Not show link if main club page.
    if (pathname === pathClub) return forumTitle;

    return (
      <Link
        {...bemClasses('link')}
        builder={linksForum.pageClub}
        builderProps={data}
      >
        <span {...bemClasses('linkContent')}>
          {forumTitle}
        </span>
      </Link>
    );
  }

  renderMainHeadBtns(dataObj = {}, auth = {}) {
    if (dataObj.clubTypeValue === 'closed' && !dataObj.clubUserStatus) {
      return null;
    }

    return (
      <DropDown
        {...bemClassesDD({ extra: this.props.className })}
        ref={ref => this.ddRefMain = ref}
        modalHeader="Меню"
        list
        inForm
        wAuto
      >
        <Button
          iconType={iconTypes.moreVertical}
          iconOnly
        />
        <div {...bemClassesDD('contentContainer')}>
          <div {...bemClassesDD('content')}>
            {/* If user is author this club */}
            {dataObj.showEditButton &&
              <ModalButton
                {...bemClassesDD('btn')}
                buttonProps={{
                  iconType: iconTypes.edit,
                  label: 'Изменить клуб',
                  title: 'Изменить клуб',
                  inListDD: true
                }}
                size="big"
              >
                <Header closeButton>Изменить клуб</Header>
                <Content>
                  <ClubUserAddForm
                    id={this.props.params.id}
                    router={this.props.router}
                    clubId={dataObj.id}
                  />
                </Content>
              </ModalButton>
            }
            {dataObj.allRules &&
              <Button
                iconType={iconTypes.checkboxCheckedAll}
                title="Отметить все темы прочитанными"
                label="Отметить все темы прочитанными"
                inListDD
              />
            }
            {(dataObj.showEditButton || dataObj.allRules) &&
              <Button
                iconType={iconTypes.delete}
                title="Удалить клуб"
                label="Удалить клуб"
                inListDD
              />
            }
            {auth.authenticated &&
              <Button
                iconType={iconTypes.favoritesBorder}
                title="В избранное"
                label="В избранное"
                inListDD
              />
            }
            <SubscribeModal
              title="Подписаться на Клуб"
              inListDD
            />
            {auth.authenticated &&
              <Share inListDD />
            }
            {/* {auth.authenticated &&
              <Complaint
                entity="comment"
                entityId={+this.props.params.id}
                closeDropDown={this.closeMainDropdown}
                // dataView="viewBlockCommentsDd"
                withIcon
                inListDD
              />
            } */}
            {!dataObj.allRules &&
              <ClubButtonJoin
                {...bemClasses('btn', 'joinToClub')}
                item={dataObj}
                auth={auth}
                actionDoLogin={this.props.actionDoLogin}
                onClick={this.closeMainDropdown}
                buttonProps={{
                  iconType: iconTypes.logIn,
                  theme: false,
                  small: false,
                  inListDD: true
                }}
              />
            }
          </div>
        </div>
      </DropDown>
    );
  }

  // Show content for club.
  renderClubContent(dataObj) {
    const {
      params = {},
      router,
      preloadedClubTopicList, preloadedClubUsersList
    } = this.props;

    const { selectedThemes } = this.state;

    let closedClubText = null;

    if (dataObj.clubTypeValue === 'closed' && !dataObj.clubUserStatus) {
      closedClubText = 'Это закрытый клуб. Читать темы могут только члены клуба.';

      if (dataObj.order_status === 'request') {
        closedClubText = (
          <div>
            <div>
              {closedClubText}
            </div>
            <div style={{ marginTop: 20 }}>
              Ваша заявка на вступление в закрытый клуб находится в обработке.
              Вы получите сообщение на e-mail о результате рассмотрения заявки.
            </div>
          </div>
        );
      }
    }

    if (!closedClubText) {
      return (
        <ClubContent
          params={params}
          data={dataObj}
          router={router}
          preloadedClubTopicList={preloadedClubTopicList}
          preloadedClubUsersList={preloadedClubUsersList}
          selectedThemes={selectedThemes}
          onHandleSelectTheme={this.onHandleSelect}
        />
      );
    }

    return (
      <div style={{ paddingLeft: 20 }}>
        {closedClubText}
      </div>
    );
  }

  renderAddInfo(data = {}, auth = {}) {
    return (
      <div {...bemClasses('info')}>
        {data.club_type &&
          <div {...bemClasses('item')}>
            <div {...bemClasses('status')}>
              <span {...bemClasses('text')}>{data.club_type} клуб</span>
            </div>
          </div>
        }
        {!!data.count_users_in_club &&
          <div {...bemClasses('item')}>
            <span {...bemClasses('text', 'before')}>▪</span>
            <span {...bemClasses('text')}>{numDesc(beautifyNumber(data.count_users_in_club), 'участник', 'участника', 'участников')}</span>
          </div>
        }
        {data.lastActivity &&
          <div {...bemClasses('item', 'mpWFull')}>
            <span {...bemClasses('mpNo')}>
              <span {...bemClasses('text', 'before')}>▪</span>
              <span {...bemClasses('text')}>Последняя активность: </span>
            </span>
            <Icon {...bemClasses('icon')} type={iconTypes.clock} />
            <span {...bemClasses('text')}>
              {formatDate({
                date: data.lastActivity,
                format: 'HH:MM, dd mmmm yyyy'
              })}
            </span>
          </div>
        }
        {(auth.authenticated && data.clubUserStatus) &&
          <div {...bemClasses('item')}>
            <span {...bemClasses('text', 'before')}>▪</span>
            <span {...bemClasses('text')}>Мой клуб</span>
          </div>
        }
      </div>
    );
  }

  render() {
    const { i18n } = this;
    const {
      className, params = {}, auth = {},
      data = [], router,
      noThemesList
    } = this.props;
    let { showDesc = true } = this.props;
    const dataObj = data[0] || {};

    if (dataObj.forum_type !== 'club') return null;

    const usersPage = linksForum.pageClub({ ...dataObj, usersPage: true }).href;
    const forumPage = linksForum.pageClub(dataObj).href;
    const { selectedThemes } = this.state;

    if (params.status) showDesc = false;

    return (
      <Col mdAdjust={330} mtOrder={1} mpOrder={1} allPr={0}>
        <div {...bemClasses({ extra: className, modifier: noThemesList && 'noThemesList' })}>
          <div {...bemClasses('row', 'top')}>
            <div {...bemClasses('column')}>
              <Thumb
                {...bemClasses('img')}
                image={{ id: dataObj.club_image }}
                updateEvent="updateClubList"
              />
            </div>
            <div {...bemClasses('column', 'full')}>
              <div {...bemClasses('clubTop')}>
                <div {...bemClasses('row')}>
                  <div {...bemClasses('column', 'full')}>
                    {dataObj.forum_title &&
                      <div {...bemClasses('topic')}>
                        {this.showTitle(dataObj)}
                      </div>
                    }
                  </div>
                  <div {...bemClasses('column')}>
                    <span style={{ whiteSpace: 'nowrap' }}>
                      <Button
                        iconType={iconTypes.search}
                        title="Найти"
                        iconOnly
                      />
                      {this.renderMainHeadBtns(dataObj, auth)}
                    </span>
                  </div>
                </div>
                <div {...bemClasses('row')}>
                  {this.renderAddInfo(dataObj, auth)}
                </div>
              </div>
              {(showDesc && dataObj.forum_description) &&
                <div {...bemClasses('clubBottom')}>
                  <div {...bemClasses('row')}>
                    <span {...bemClasses('text')}>
                      <StringCutter
                        string={dataObj.forum_description}
                      />
                    </span>
                  </div>
                </div>
              }
            </div>
          </div>
          <TabControl {...bemClasses('tabs')}>
            <tab
              onSelected={() => router.push(forumPage)}
              selected={!params.status}
            >
              <tabTitle>Форум</tabTitle>
            </tab>
            <tab
              onSelected={() => router.push(usersPage)}
              selected={params.status}
            >
              <tabTitle>Пользователи</tabTitle>
            </tab>
            {!dataObj.allRules && !dataObj.clubUserStatus && (dataObj.order_status !== 'request') &&
              <aside {...bemClasses('tabsAside')}>
                <ClubButtonJoin
                  {...bemClasses('btn', 'joinToClub')}
                  item={dataObj}
                  auth={auth}
                  actionDoLogin={this.props.actionDoLogin}
                  dataClub={dataObj}
                />
              </aside>
            }
          </TabControl>
        </div>
        {!noThemesList &&
          <Block {...bemClassesBlock({ extra: className })}>
            <BlockContent noPaddingLR noPaddingT>
              {/* Show club content */}
              {this.renderClubContent(dataObj)}
              {(
                !params.status &&
                ((auth.authenticated && dataObj.clubUserStatus) ||
                dataObj.allRules)
              ) &&
                <ForumTopicAdd
                  forum_id={dataObj.id}
                  router={this.props.router}
                  modalBtnProps={{
                    iconType: iconTypes.addPlus,
                    title: 'Создать тему/Опросы',
                    dataView: btnViews.float
                  }}
                  modalSize="big"
                  hideModalBtn
                  modalHeaderTitle={i18n('Добавить тему / Опросы')}
                />
              }
              {dataObj.allRules &&
                <AdminPanel
                  selectedItems={selectedThemes}
                  onHandleDelete={this.onHandleDeleteTheme}
                  onResetSelection={this.onHandleSelect}
                  entity="themes"
                />
              }
            </BlockContent>
          </Block>
        }
        <AdSense />
      </Col>
    );
  }
}
